import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const LineReveal = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.18em] -mb-[0.18em] ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ number, kicker, children }) => (
  <div className="relative">
    <span
      aria-hidden
      className="pointer-events-none select-none absolute -top-10 md:-top-24 -left-2 md:-left-6 font-mono text-[6rem] md:text-[12rem] leading-none text-transparent"
      style={{ WebkitTextStroke: "1px rgba(28,22,16,0.14)" }}
    >
      {number}
    </span>
    {kicker && (
      <FadeUp>
        <p className="font-mono text-xs tracking-[0.35em] uppercase text-[#950606] mb-6">
          {number} · {kicker}
        </p>
      </FadeUp>
    )}
    {children}
  </div>
);
